import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText } from "@mui/material";

import { GroupFormData } from "../../types/group.types";

const groupPrivacyOptions = [
  {
    value: "public",
    label: "public",
  },
  {
    value: "private",
    label: "private",
  },
  {
    value: "closed",
    label: "closed",
  },
];

export const GroupPrivacy = () => {
  const { control } = useFormContext<GroupFormData>();
  const { t } = useTranslation("groups");

  return (
    <Controller
      name="groupPrivacy"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "4px" }}>
          <FormLabel
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 700,
            }}
          >
            {t("groupPrivacy")}
          </FormLabel>
          <RadioGroup {...field} onChange={(e) => field.onChange(e.target.value as GroupFormData["groupPrivacy"])}>
            {groupPrivacyOptions.map((option) => (
              <FormControlLabel
                sx={{
                  "& .MuiFormControlLabel-label": {
                    color: "var(--black-100, #1C1C1C)",
                    fontFamily: "Montserrat",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "20px",
                  },
                }}
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={t(option.label)}
              />
            ))}
          </RadioGroup>
          {error && <FormHelperText>{t(error.message)}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
